import { ArrowDown, ArrowUp, Asterisk, CalendarPlus, ChartGantt, Check, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, CircleAlert, Clock, Copy, Eye, File, Folder, Globe, Info, Link, List, Lock, LogOut, MessageCircleQuestionMark, Network, Paperclip, Pencil, Play, Plus, RefreshCw, Search, Sparkles, Square, SquareKanban, Star, Table2, TextAlignStart, Trash2, TriangleAlert, X } from "lucide-react";
import React from "react";
const FILLED = {
    fill: "currentColor",
    stroke: "none"
};
function fromLucide(Glyph, isFilled = false) {
    return function Icon({ size = 16, strokeWidth = 1.5, style, ...rest }) {
        return /*#__PURE__*/ React.createElement(Glyph, {
            size: size,
            strokeWidth: strokeWidth,
            "aria-hidden": true,
            focusable: false,
            style: {
                flexShrink: 0,
                ...style
            },
            ...isFilled ? FILLED : {},
            ...rest
        });
    };
}
export const PlusIcon = fromLucide(Plus);
export const SendIcon = fromLucide(ArrowUp);
export const StopIcon = fromLucide(Square, true);
export const LinkIcon = fromLucide(Link);
export const PaperclipIcon = fromLucide(Paperclip);
export const CopyIcon = fromLucide(Copy);
export const CheckIcon = fromLucide(Check);
export const ChevronLeftIcon = fromLucide(ChevronLeft);
export const ChevronRightIcon = fromLucide(ChevronRight);
export const ChevronDownIcon = fromLucide(ChevronDown);
export const ChevronUpIcon = fromLucide(ChevronUp);
export const SearchIcon = fromLucide(Search);
export const StarIcon = fromLucide(Star);
export const PencilIcon = fromLucide(Pencil);
export const TrashIcon = fromLucide(Trash2);
export const FolderIcon = fromLucide(Folder);
export const DocumentIcon = fromLucide(File);
export const TimelineIcon = fromLucide(ChartGantt);
export const TimelineCreateIcon = fromLucide(CalendarPlus);
export const StructureIcon = fromLucide(Network);
export const InsightIcon = fromLucide(Table2);
export const BoardIcon = fromLucide(SquareKanban);
export const FormatIcon = fromLucide(TextAlignStart);
export const SparklesIcon = fromLucide(Sparkles);
export const ListLinesIcon = fromLucide(List);
export const GlobeIcon = fromLucide(Globe);
export const LockIcon = fromLucide(Lock);
export const AlertIcon = fromLucide(TriangleAlert);
export const ErrorIcon = fromLucide(CircleAlert);
export const InfoIcon = fromLucide(Info);
export const RefreshIcon = fromLucide(RefreshCw);
export const LogoutIcon = fromLucide(LogOut);
export const CloseIcon = fromLucide(X);
export const ReasoningIcon = fromLucide(Asterisk);
export const PlayIcon = fromLucide(Play);
export const EyeIcon = fromLucide(Eye);
export const ClockIcon = fromLucide(Clock);
export const QuestionIcon = fromLucide(MessageCircleQuestionMark);
export const ArrowDownIcon = fromLucide(ArrowDown);
